import {
  INITIALIZE_PAY_DATA,
  INITIALIZE_PAY_DATA_SUCCESS,
  GET_INSTALLMENTS,
  GET_INSTALLMENTS_SUCCESS,
  GET_INSTALLMENTS_FAIL,
  INSTALLMENT_API_ERROR,
} from "./actionTypes"

const INIT_STATE = {
  recordList: [],
  error: null,
  waitingRecordListUpdate: false,
}

const installment = (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_INSTALLMENTS:
      return {
        ...state,
        recordList: [],
        loading: true,
        error: null,
      }
    case GET_INSTALLMENTS_SUCCESS:
      return {
        ...state,
        recordList: action.payload,
        loading: false,
        error: null,
      }
    case GET_INSTALLMENTS_FAIL:
    case INSTALLMENT_API_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        recordList: [],
      }
    case INITIALIZE_PAY_DATA_SUCCESS:
      return {
        ...state,
        payData: action.payload,
      }

    default:

      return state

  }
}

export default installment